var _g, _g2, _g3, _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _path5, _rect4, _path6, _rect5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _path16, _rect6, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSvgPj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 466.595,
    height: 458,
    viewBox: "0 0 466.595 458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-39.68 -34.05)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7",
    transform: "translate(39.68 34.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M482,324.943H303V221.36H482Zm-177.907-1.092H480.907v-101.4H304.092Z",
    transform: "translate(-15.404 -16.781)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 118.099,
    height: 3.462,
    transform: "translate(311.57 259.811)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 126.236,
    height: 3.779,
    transform: "translate(311.57 272.72)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 126.236,
    height: 3.779,
    transform: "translate(311.57 285.783)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 41.274,
    height: 8.989,
    transform: "translate(311.57 241.058)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 177.874,
    height: 16.492,
    transform: "translate(288.175 205.125)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M453.861,235.677c-.229-.218,2.064-2.982,5.111-6.171s5.723-5.6,5.942-5.4-2.064,2.982-5.111,6.182S454.08,235.9,453.861,235.677Z",
    transform: "translate(-1.497 -16.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M464.934,235.677c-.218.218-2.883-2.184-5.942-5.384s-5.341-5.963-5.111-6.182,2.883,2.184,5.942,5.4S465.142,235.459,464.934,235.677Z",
    transform: "translate(-1.495 -16.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 177.874,
    height: 102.502,
    transform: "translate(68.459)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 118.099,
    height: 3.462,
    transform: "translate(91.864 54.697)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 126.236,
    height: 3.779,
    transform: "translate(91.864 67.607)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 126.236,
    height: 3.779,
    transform: "translate(91.864 80.669)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 41.274,
    height: 8.989,
    transform: "translate(91.864 35.944)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 177.874,
    height: 16.492,
    transform: "translate(68.459)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M252.141,47.8c-.229-.208,2.064-2.982,5.111-6.171s5.723-5.6,5.942-5.385-2.064,2.982-5.111,6.171S252.36,47.993,252.141,47.8Z",
    transform: "translate(-20.094 -33.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M263.194,47.8c-.218.218-2.883-2.184-5.942-5.385s-5.341-5.952-5.111-6.171,2.883,2.184,5.941,5.385S263.424,47.589,263.194,47.8Z",
    transform: "translate(-20.094 -33.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M218.647,217.134H39.68V113.54H218.647ZM40.772,216.042H217.554V114.632H40.772Z",
    transform: "translate(-39.68 -26.722)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 118.099,
    height: 3.462,
    transform: "translate(23.952 142.061)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 126.236,
    height: 3.779,
    transform: "translate(23.952 154.971)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 126.236,
    height: 3.779,
    transform: "translate(23.952 168.034)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 41.274,
    height: 8.989,
    transform: "translate(23.952 123.309)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 177.874,
    height: 16.492,
    transform: "translate(0.546 87.364)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 210.029,
    height: 188.032,
    transform: "translate(175.483 214.146)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 164.528,
    height: 170.939,
    transform: "translate(21.516 154.917)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 164.528,
    height: 18.622,
    transform: "translate(21.516 154.917)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M72.4,184.544a3.451,3.451,0,1,1-3.451-3.6A3.538,3.538,0,0,1,72.4,184.544Z",
    transform: "translate(-37.299 -20.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M85.234,184.544a3.462,3.462,0,1,1-3.451-3.6A3.538,3.538,0,0,1,85.234,184.544Z",
    transform: "translate(-36.118 -20.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M98.064,184.544a3.462,3.462,0,1,1-3.451-3.6A3.538,3.538,0,0,1,98.064,184.544Z",
    transform: "translate(-34.936 -20.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 210.029,
    height: 209.33,
    transform: "translate(233.074 37.386)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 210.029,
    height: 24.52,
    transform: "translate(233.074 37.386)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M270.228,79.681a4.554,4.554,0,1,1-4.554-4.751A4.663,4.663,0,0,1,270.228,79.681Z",
    transform: "translate(-19.265 -30.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M285.8,76.461a4.554,4.554,0,1,1-6.553-.153A4.642,4.642,0,0,1,285.8,76.461Z",
    transform: "translate(-17.719 -30.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M304.008,79.681a4.554,4.554,0,1,1-4.554-4.751A4.663,4.663,0,0,1,304.008,79.681Z",
    transform: "translate(-16.15 -30.281)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7",
    transform: "translate(98.647 491.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M432.435,453.154c0,.153-75.842.284-169.366.284s-169.4-.131-169.4-.284,75.831-.284,169.4-.284S432.435,453.012,432.435,453.154Z",
    transform: "translate(-93.67 -452.87)",
    fill: "#263238"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-7",
    transform: "translate(338.111 39.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M376.944,61.612l-5.625,2.01-2.414-7.35C364.471,42.717,350.338,35.52,337.352,40.1s-19.9,19.441-15.465,33l2.414,7.35-5.647,2.021A8.978,8.978,0,0,0,313.39,93.69l15.651,47.827a8.443,8.443,0,0,0,10.511,5.663c.086-.026.173-.054.258-.082l58.29-20.85a9.022,9.022,0,0,0,5.319-11.337L387.757,67.084a8.421,8.421,0,0,0-10.529-5.565C377.133,61.549,377.038,61.58,376.944,61.612Zm-44.43,7.645a14.406,14.406,0,0,1,8.475-18.076,13.5,13.5,0,0,1,17.143,8.4c.051.151.1.3.146.455l2.4,7.35-25.765,9.218ZM365.28,111.7l4,12.211a.993.993,0,0,1-.623,1.223l-5.6,2a.9.9,0,0,1-1.092-.59l-4.03-12.156a10.921,10.921,0,0,1-9.83-7.645,11.48,11.48,0,0,1,6.761-14.4,10.759,10.759,0,0,1,13.659,6.7c.039.118.078.236.114.354a11.665,11.665,0,0,1-3.342,12.331Z",
    transform: "translate(-312.921 -38.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M370.129,61.4c0,.153-10.43,4.074-23.406,8.738s-23.559,8.41-23.613,8.3,10.43-4.063,23.417-8.738S370.074,61.258,370.129,61.4Z",
    transform: "translate(-311.981 -36.629)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M381.136,63.24a1.918,1.918,0,0,1,.12.295c.087.218.186.5.317.852.284.8.677,1.9,1.169,3.277l4.194,12.211c1.748,5.177,3.834,11.315,6.149,18.13,1.092,3.419,2.381,6.979,3.582,10.725a16.381,16.381,0,0,1,.819,6,8.05,8.05,0,0,1-.885,3.025,8.35,8.35,0,0,1-2.064,2.436,19.657,19.657,0,0,1-5.548,2.829l-5.625,2.021-10.649,3.812-18.032,6.422-12.178,4.281-3.277,1.092-.874.284a.925.925,0,0,1-.295.076.573.573,0,0,0,.273-.131l.852-.339,3.277-1.234,12.112-4.456,18-6.553,10.627-3.845,5.625-2.031a18.7,18.7,0,0,0,5.385-2.741,7.758,7.758,0,0,0,1.922-2.261,7.172,7.172,0,0,0,.819-2.807,15.715,15.715,0,0,0-.786-5.778c-1.18-3.713-2.425-7.307-3.55-10.725-2.272-6.826-4.369-12.986-6.029-18.163s-3.058-9.338-4.019-12.265c-.459-1.431-.808-2.545-1.092-3.353l-.262-.874A1.007,1.007,0,0,1,381.136,63.24Z",
    transform: "translate(-310.603 -36.459)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M351.3,49.628s-.579-.284-1.649-.721a14.546,14.546,0,0,0-4.773-.961,16.39,16.39,0,0,0-7.056,1.332,15.727,15.727,0,0,0-6.673,5.581,14.763,14.763,0,0,0-2.567,8.29,25.569,25.569,0,0,0,1.092,7.154c.568,1.988,1.158,3.571,1.551,4.675A12.27,12.27,0,0,1,331.8,76.7a9.584,9.584,0,0,1-.775-1.649c-.448-1.092-1.092-2.643-1.726-4.642a24.815,24.815,0,0,1-1.256-7.263,14.97,14.97,0,0,1,2.621-8.606A15.98,15.98,0,0,1,337.6,48.8a16.256,16.256,0,0,1,7.263-1.245A13.764,13.764,0,0,1,349.7,48.7a9.01,9.01,0,0,1,1.18.655A1.619,1.619,0,0,1,351.3,49.628Z",
    transform: "translate(-311.527 -37.908)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M350.352,88.7a3.805,3.805,0,0,1,.546-.273,10.83,10.83,0,0,1,1.693-.6,12.125,12.125,0,0,1,2.829-.481,9.589,9.589,0,0,1,3.834.579c2.8.983,5.363,3.834,6.63,7.645a11.014,11.014,0,0,1,0,6.269,14.2,14.2,0,0,1-3.517,5.887l.066-.295c1.453,3.986,3.036,8.312,4.675,12.822l.1.273-.273.1-2.5.83-5.461,1.824-.273.087-.087-.273c-1.5-4.522-3.135-8.738-4.369-12.877l.24.186a10.917,10.917,0,0,1-5.854-2.3,13.215,13.215,0,0,1-3.659-4.369,9.985,9.985,0,0,1-1.158-4.915,11.861,11.861,0,0,1,4.576-9.021,6.945,6.945,0,0,1,1.889-1.092,21.049,21.049,0,0,0-1.791,1.19,11.6,11.6,0,0,0-3.375,4.795,10.332,10.332,0,0,0,.339,8.814,12.826,12.826,0,0,0,3.571,4.194,10.4,10.4,0,0,0,5.581,2.184h.186l.055.164c1.2,4.063,2.851,8.312,4.369,12.855l-.36-.175,5.461-1.824,2.49-.841-.175.371c-1.627-4.511-3.2-8.847-4.642-12.833v-.164l.131-.131a13.912,13.912,0,0,0,3.451-5.647,10.569,10.569,0,0,0,0-6c-1.19-3.67-3.648-6.455-6.313-7.438a9.4,9.4,0,0,0-3.7-.623,12.512,12.512,0,0,0-2.8.382C351.128,88.379,350.363,88.75,350.352,88.7Z",
    transform: "translate(-310.073 -34.238)",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-7",
    transform: "translate(211.886 87.436)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M330.1,404.46l-109.1-.5a23.776,23.776,0,0,1-23.646-23.875l1.158-273.5A23.755,23.755,0,0,1,222.361,82.93h.022l109.088.5A23.777,23.777,0,0,1,355.128,107.3L353.97,380.782A23.777,23.777,0,0,1,330.1,404.46Z",
    transform: "translate(-197.35 -82.93)",
    fill: "#00406f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M330.694,92.031H309.549a5.253,5.253,0,0,0-5.155,5.35v3.836a5.242,5.242,0,0,1-5.142,5.341h-.013l-41.219-.186a5.265,5.265,0,0,1-5.122-5.4V97.143a5.264,5.264,0,0,0-5.111-5.4h-7.438l-18.513-.087a16.645,16.645,0,0,0-16.743,16.481L204,375.095a16.634,16.634,0,0,0,16.558,16.711h0l108.87.5a16.645,16.645,0,0,0,16.721-16.569h0l1.092-266.954A16.656,16.656,0,0,0,330.694,92.031Z",
    transform: "translate(-196.737 -82.125)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M313.551,336.48l-80.953-.35c-.841,0-1.518-.917-1.507-2.031l.087-21.178c0-1.092.688-2.031,1.529-2.031l80.953.371a1.834,1.834,0,0,1,1.507,2.042l-.076,21.156C315.091,335.584,314.391,336.491,313.551,336.48Z",
    transform: "translate(-194.239 -61.914)",
    fill: "#003242"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 5.155,
    height: 28.091,
    transform: "translate(26.391 93.408) rotate(-89.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 5.155,
    height: 28.091,
    transform: "translate(26.391 93.408) rotate(-89.74)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M332,194.454a2.52,2.52,0,0,0,.644-.153,1.726,1.726,0,0,0,1.092-1.474v-14.5a2.12,2.12,0,0,0-.306-1.431,1.636,1.636,0,0,0-1.3-.666H314.649l-91.351-.339a1.453,1.453,0,0,0-1.2.6,2.081,2.081,0,0,0-.284,1.431v13.106a8.513,8.513,0,0,0,0,1.529,1.474,1.474,0,0,0,.852.983,1.71,1.71,0,0,0,.677.12H228.9l24.258.131,41.066.251,27.687.218,7.525.087H294.225l-41.066-.131-24.258-.1h-5.559a2.183,2.183,0,0,1-.9-.153,2.053,2.053,0,0,1-1.18-1.365,3.09,3.09,0,0,1-.066-.874V177.809a6.139,6.139,0,0,1,0-.874,1.852,1.852,0,0,1,.36-.885,2.008,2.008,0,0,1,1.66-.841l91.351.5,15.782.109h1.7a1.867,1.867,0,0,1,1.529.8,2.324,2.324,0,0,1,.35,1.606V185.2c0,3.277-.076,5.789-.1,7.536a1.769,1.769,0,0,1-1.147,1.518A1.308,1.308,0,0,1,332,194.454Z",
    transform: "translate(-195.152 -74.422)",
    fill: "#e0e0e0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 51.377,
    height: 4.817,
    transform: "translate(34.852 106.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 51.377,
    height: 4.817,
    transform: "translate(34.852 106.948)",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 5.155,
    height: 28.091,
    transform: "translate(26.199 140.437) rotate(-89.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 5.155,
    height: 28.091,
    transform: "translate(26.199 140.437) rotate(-89.74)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M331.316,237.5a5.8,5.8,0,0,0,.655-.12,2.24,2.24,0,0,0,1.376-1.245,3.066,3.066,0,0,0,.2-1.387v-13.03a2.346,2.346,0,0,0-.317-1.442,2.12,2.12,0,0,0-1.19-.928,6.675,6.675,0,0,0-1.649-.087H314.671l-91.034-.339a2.021,2.021,0,0,0-2,1.758v13.106a6.288,6.288,0,0,0,.066,1.529,2.081,2.081,0,0,0,.8,1.092,2.277,2.277,0,0,0,1.354.35h4.675l24.17.12,40.924.251,27.589.218,7.5.087H293.624l-40.946-.044-24.17-.087h-4.751a2.742,2.742,0,0,1-1.671-.448,2.621,2.621,0,0,1-1.027-1.431,6.833,6.833,0,0,1-.087-1.682V220.641a2.588,2.588,0,0,1,2.567-2.261l91.034.5,15.717.12a6.749,6.749,0,0,1,1.748.12,2.412,2.412,0,0,1,1.343,1.092,2.628,2.628,0,0,1,.349,1.595v13.084a3.056,3.056,0,0,1-.229,1.431,2.317,2.317,0,0,1-1.474,1.245A2.05,2.05,0,0,1,331.316,237.5Z",
    transform: "translate(-195.174 -70.442)",
    fill: "#e0e0e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 5.155,
    height: 28.091,
    transform: "translate(25.988 189.507) rotate(-89.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 5.155,
    height: 28.091,
    transform: "translate(25.988 189.507) rotate(-89.74)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M331.107,282.426a5.316,5.316,0,0,0,.655-.12,2.252,2.252,0,0,0,1.376-1.234,3.081,3.081,0,0,0,.2-1.387V266.644a2.346,2.346,0,0,0-.317-1.442,2.186,2.186,0,0,0-1.19-.917,6.677,6.677,0,0,0-1.649-.1H314.462l-91.034-.339a2.021,2.021,0,0,0-2,1.758v13.106a6.2,6.2,0,0,0,.066,1.518,2,2,0,0,0,.8,1.092,2.183,2.183,0,0,0,1.354.349H228.4l24.17.131,40.924.251,27.589.218,7.5.087H293.492l-40.924-.12-24.17-.1h-4.751a2.676,2.676,0,0,1-1.671-.448,2.621,2.621,0,0,1-1.027-1.431,6.833,6.833,0,0,1-.087-1.682V265.421a2.578,2.578,0,0,1,2.556-2.261l91.034.5,15.717.12a6.748,6.748,0,0,1,1.747.12,2.412,2.412,0,0,1,1.343,1.092,2.628,2.628,0,0,1,.349,1.595v13.084a3,3,0,0,1-.229,1.431,2.317,2.317,0,0,1-1.474,1.245A1.733,1.733,0,0,1,331.107,282.426Z",
    transform: "translate(-195.184 -66.314)",
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 4.817,
    height: 51.377,
    transform: "translate(33.734 159.923) rotate(-89.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 4.817,
    height: 51.377,
    transform: "translate(33.734 159.923) rotate(-89.74)",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M232.889,272.844a2.25,2.25,0,1,1-2.184-2.414A2.316,2.316,0,0,1,232.889,272.844Z",
    transform: "translate(-194.488 -65.644)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M239.259,272.873a2.25,2.25,0,0,1-4.489.313,2.141,2.141,0,0,1,0-.313,2.25,2.25,0,0,1,4.489-.313A2.15,2.15,0,0,1,239.259,272.873Z",
    transform: "translate(-193.9 -65.64)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M245.639,272.9a2.25,2.25,0,1,1-2.184-2.414A2.326,2.326,0,0,1,245.639,272.9Z",
    transform: "translate(-193.312 -65.638)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M252.009,272.934a2.25,2.25,0,1,1-2.184-2.414A2.326,2.326,0,0,1,252.009,272.934Z",
    transform: "translate(-192.725 -65.636)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M258.379,272.953a2.25,2.25,0,1,1-2.184-2.4A2.327,2.327,0,0,1,258.379,272.953Z",
    transform: "translate(-192.138 -65.633)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M264.759,272.983a2.25,2.25,0,1,1-2.239-2.4A2.326,2.326,0,0,1,264.759,272.983Z",
    transform: "translate(-191.549 -65.63)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M271.129,273.013a2.25,2.25,0,1,1-4.489.313,2.141,2.141,0,0,1,0-.313,2.25,2.25,0,1,1,4.489-.313A2.149,2.149,0,0,1,271.129,273.013Z",
    transform: "translate(-190.962 -65.628)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M277.5,273.043a2.25,2.25,0,1,1-2.239-2.4A2.326,2.326,0,0,1,277.5,273.043Z",
    transform: "translate(-190.375 -65.624)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M283.869,273.073a2.25,2.25,0,1,1-2.184-2.4A2.327,2.327,0,0,1,283.869,273.073Z",
    transform: "translate(-189.788 -65.622)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(33.908 204.785)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M232.889,272.844a2.25,2.25,0,1,1-2.184-2.414A2.316,2.316,0,0,1,232.889,272.844Z",
    transform: "translate(-228.395 -270.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M239.259,272.873a2.25,2.25,0,0,1-4.489.313,2.141,2.141,0,0,1,0-.313,2.25,2.25,0,0,1,4.489-.313A2.15,2.15,0,0,1,239.259,272.873Z",
    transform: "translate(-227.808 -270.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M245.639,272.9a2.25,2.25,0,1,1-2.184-2.414A2.326,2.326,0,0,1,245.639,272.9Z",
    transform: "translate(-227.22 -270.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M252.009,272.934a2.25,2.25,0,1,1-2.184-2.414A2.326,2.326,0,0,1,252.009,272.934Z",
    transform: "translate(-226.633 -270.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M258.379,272.953a2.25,2.25,0,1,1-2.184-2.4A2.327,2.327,0,0,1,258.379,272.953Z",
    transform: "translate(-226.045 -270.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M264.759,272.983a2.25,2.25,0,1,1-2.239-2.4A2.326,2.326,0,0,1,264.759,272.983Z",
    transform: "translate(-225.457 -270.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M271.129,273.013a2.25,2.25,0,1,1-4.489.313,2.141,2.141,0,0,1,0-.313,2.25,2.25,0,1,1,4.489-.313A2.149,2.149,0,0,1,271.129,273.013Z",
    transform: "translate(-224.87 -270.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M277.5,273.043a2.25,2.25,0,1,1-2.239-2.4A2.326,2.326,0,0,1,277.5,273.043Z",
    transform: "translate(-224.283 -270.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M283.869,273.073a2.25,2.25,0,1,1-2.184-2.4A2.327,2.327,0,0,1,283.869,273.073Z",
    transform: "translate(-223.696 -270.407)",
    fill: "#fff"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M275.177,129.194a4.227,4.227,0,0,0,2.523-3.921,3.976,3.976,0,0,0-7.94-.417,3.79,3.79,0,0,0,0,.417,4.237,4.237,0,0,0,2.534,3.965c-6.116.917-5.843,7.558-5.843,7.558l14.461.066S281.249,130.1,275.177,129.194Z",
    transform: "translate(-190.979 -79.412)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M275.177,129.194a4.227,4.227,0,0,0,2.523-3.921,3.976,3.976,0,0,0-7.94-.417,3.79,3.79,0,0,0,0,.417,4.237,4.237,0,0,0,2.534,3.965c-6.116.917-5.843,7.558-5.843,7.558l14.461.066S281.249,130.1,275.177,129.194Z",
    transform: "translate(-190.979 -79.412)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 6.16,
    height: 51.541,
    transform: "translate(56.127 67.659) rotate(-89.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 6.16,
    height: 51.541,
    transform: "translate(56.127 67.659) rotate(-89.74)",
    fill: "#262626",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7",
    transform: "translate(130.092 187.585)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M172.575,449.138V439.8l-16.743-.12L155.69,453.8l1.038.076c4.62.295,23.5.732,26.606-.229C186.785,452.579,172.575,449.138,172.575,449.138Z",
    transform: "translate(-119.396 -150.189)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M183.722,451.694c0,.153-6.269.284-13.991.284s-13.991-.131-13.991-.284,6.269-.284,13.991-.284S183.722,451.541,183.722,451.694Z",
    transform: "translate(-119.392 -149.107)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M171.425,450.238c-.142-.076,0-.568.339-1.092s.8-.743.907-.633-.12.524-.448.972S171.567,450.314,171.425,450.238Z",
    transform: "translate(-117.951 -149.377)",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M172.406,450.823c-.153,0-.076-.612.251-1.19s.765-.928.885-.841-.076.579-.382,1.092S172.548,450.877,172.406,450.823Z",
    transform: "translate(-117.862 -149.35)",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M160.768,451.907c-.066,0-.317-.2-.677-.612a10.9,10.9,0,0,0-1.464-1.464,3.857,3.857,0,0,0-1.813-.8c-.513-.066-.841,0-.874-.066s.284-.295.885-.339a3.374,3.374,0,0,1,2.184.743,6.164,6.164,0,0,1,1.442,1.693C160.7,451.546,160.833,451.863,160.768,451.907Z",
    transform: "translate(-119.374 -149.364)",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M171.607,448.485c.076.131-.208.459-.688.633s-.907.109-.928,0,.317-.339.732-.491S171.519,448.354,171.607,448.485Z",
    transform: "translate(-118.078 -149.382)",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M171.4,447.673c0,.164-.437.295-1,.306s-1.016-.12-1-.273.459-.295,1-.306S171.378,447.52,171.4,447.673Z",
    transform: "translate(-118.133 -149.477)",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M210.325,449.138V439.8l-16.743-.12-.142,13.98,1.038.076c4.62.295,23.515.874,26.606-.087C224.535,452.579,210.325,449.138,210.325,449.138Z",
    transform: "translate(-115.916 -150.189)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M221.471,451.714c0,.153-6.258.284-13.991.284s-13.98-.131-13.98-.284,6.258-.284,13.98-.284S221.471,451.561,221.471,451.714Z",
    transform: "translate(-115.911 -149.105)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M209.174,450.238c-.131-.076,0-.568.339-1.092s.8-.743.907-.633-.12.524-.448.972S209.316,450.314,209.174,450.238Z",
    transform: "translate(-114.47 -149.377)",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M210.156,450.823c-.142,0-.076-.612.262-1.19s.765-.928.885-.841-.087.579-.393,1.092S210.309,450.877,210.156,450.823Z",
    transform: "translate(-114.382 -149.35)",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M198.518,451.907c-.066,0-.306-.2-.677-.612a10.9,10.9,0,0,0-1.464-1.464,3.857,3.857,0,0,0-1.813-.8c-.5-.066-.841,0-.874-.066s.284-.295.885-.339a3.374,3.374,0,0,1,2.184.743,5.978,5.978,0,0,1,1.442,1.693C198.452,451.546,198.583,451.863,198.518,451.907Z",
    transform: "translate(-115.893 -149.364)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M209.357,448.485c.076.131-.208.459-.688.633s-.907.109-.928,0,.317-.339.732-.491S209.269,448.354,209.357,448.485Z",
    transform: "translate(-114.598 -149.382)",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M209.169,447.673c0,.164-.437.295-1,.306s-1-.12-.994-.273.448-.295.994-.306S209.169,447.52,209.169,447.673Z",
    transform: "translate(-114.65 -149.477)",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M278.556,195.683c-.437-.448-1.518-.229-1.518-.229a5.607,5.607,0,0,0,0-1.9c-.2-.612-1.573-.492-1.573-.492a6.355,6.355,0,0,1,0-1.551.556.556,0,0,0-.317-.557,5.047,5.047,0,0,0-2.053-.371c-.841-.6,2.567-5.374,3.834-6.9s1.038-2.72-.087-2.72c-.775,0-4.751,4.587-5.974,6.127s-4.467,5.821-4.576,2.4-1.485-6-2.348-6.433-1.78.59-1.311,1.54a12.226,12.226,0,0,1,.765,3.364,8.04,8.04,0,0,1-.12,2.752,33.054,33.054,0,0,1-1.474,4.937h-.087s-23.832,22.86-25.557,24.487c-1.54,1.464-32.515-1.737-38.729-2.392a41.551,41.551,0,0,0-6.378-.437c-2.7.12-3.178.5-5.865.535a132.836,132.836,0,0,0-20.249,1.78,16.787,16.787,0,0,0-13.172,11.424c-6.258,19.55-20.435,65.826-22.936,91.821a110.35,110.35,0,0,0-5.111,10.561c-1.758,4.784-1.332,4.948-.743,5.057,1.595.295,3.408-8.29,4.085-6.215s-3.44,10.234-1.769,10.474c2.184.306,3.921-8.738,4.128-9.458s1.289-.491,1.092.186c-.317.961-3.386,11.151-1.245,11.479,1.18.175,1.311-1.977,1.311-1.977s2.184-9.753,3.178-9.557-.066,5.952-.568,7.875.2,2.894,1.223,2.425c.7-.328,2.37-6.171,2.829-8.071s1.606-7.165,3.145-4.118,3.877,4.817,4.838,4.86a1.092,1.092,0,0,0,.535-1.955,12.362,12.362,0,0,1-2.108-2.73,8.058,8.058,0,0,1-1.092-2.556,27.748,27.748,0,0,1-.765-5.527l-.175-1.092c2.447-12.112,9.491-47.663,19.659-70.37l4.172,8.585,1.813,6.357-11.119,27.447,47.423-.623-7.077-27.239,8.6-28.4h0c9.295.208,33.159.557,37.135-1.245,5-2.184,30.876-34.863,30.876-34.863h0a59.88,59.88,0,0,0,4.838-4.194S279.506,196.666,278.556,195.683Z",
    transform: "translate(-122.46 -174.041)",
    fill: "#ffbe9d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M152.636,271.388c1.376-4.7,8.443-27.916,8.443-27.916s3.473,18.928,2.556,21.21a40.488,40.488,0,0,1-2.982,5.636c-8.017,12.2-6.968,18.305-6.968,18.305l48.439-1.474c.109-6.772-3.9-22.521-4.729-25.033s1.933-10.736,1.933-10.736,5.461-5.559,5.264-8.421a46.3,46.3,0,0,0-.95-7.645l29.489,1.092-.928-19.987-42.355-4.238c-1.474,4.161-14.81,2.119-14.81,2.119-14.4.481-15.291,3.124-21.276,7.776s-15.891,44.583-15.891,44.583Z",
    transform: "translate(-121.039 -171.162)",
    fill: "#ffe101"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M179.068,262.207a10.188,10.188,0,0,1-2.545.131c-1.584,0-3.757-.109-6.149-.349s-4.554-.579-6.094-.885a10.507,10.507,0,0,1-2.479-.633,13.626,13.626,0,0,1,2.545.24c1.551.2,3.7.47,6.083.71s4.544.4,6.105.513A13.537,13.537,0,0,1,179.068,262.207Z",
    transform: "translate(-118.833 -166.71)",
    fill: "#2f9c24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M182.235,258.29a11.206,11.206,0,0,1-2.643.906,48.592,48.592,0,0,1-13.358,1.584,11.02,11.02,0,0,1-2.774-.262,18.689,18.689,0,0,1,2.774-.142c1.715-.055,4.074-.175,6.673-.481s4.915-.743,6.553-1.092A18.106,18.106,0,0,1,182.235,258.29Z",
    transform: "translate(-118.68 -166.911)",
    fill: "#2f9c24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M195.911,241.47a11.348,11.348,0,0,1-.339,2.468c-.284,1.518-.721,3.593-1.278,5.865s-1.092,4.369-1.573,5.789a10.939,10.939,0,0,1-.852,2.348,11.168,11.168,0,0,1,.459-2.446c.415-1.7.885-3.67,1.409-5.821s1.027-4.118,1.442-5.821A10.377,10.377,0,0,1,195.911,241.47Z",
    transform: "translate(-116.061 -168.462)",
    fill: "#2f9c24"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M153.107,264.18a50.762,50.762,0,0,1-7.46-1.737,51.942,51.942,0,0,1-7.318-2.294,52.46,52.46,0,0,1,7.46,1.737A51.338,51.338,0,0,1,153.107,264.18Z",
    transform: "translate(-120.997 -166.74)",
    fill: "#2f9c24"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M199.708,234.976a3.666,3.666,0,0,1-1.245,0,12.95,12.95,0,0,1-3.331-.8,13.685,13.685,0,0,1-7.907-7.765,14.114,14.114,0,0,1-.972-6.149,9.56,9.56,0,0,1,1.5-4.871,5.053,5.053,0,0,1,2.763-2.042,3.376,3.376,0,0,1,.928-.12h.328a3.541,3.541,0,0,0-1.19.295,4.97,4.97,0,0,0-2.5,2.042c-1.485,2.337-1.9,6.608-.317,10.594a13.347,13.347,0,0,0,3.375,4.937,14.329,14.329,0,0,0,4.139,2.665A21.079,21.079,0,0,0,199.708,234.976Z",
    transform: "translate(-116.582 -171.066)",
    fill: "#2f9c24"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M221.905,235.7a91.133,91.133,0,0,1-.262-10.07,90.141,90.141,0,0,1,.306-10.059,90.929,90.929,0,0,1,.262,10.059A87.291,87.291,0,0,1,221.905,235.7Z",
    transform: "translate(-113.32 -170.85)",
    fill: "#2f9c24"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M186.575,216.529c.12-2.436.371-5.188.371-5.188s6.029-.666,6.389-6.892,0-20.588,0-20.588l-10.922-5.592L170.29,187.8l1.868,31.127,11.118.71A3.211,3.211,0,0,0,186.575,216.529Z",
    transform: "translate(-118.05 -174.289)",
    fill: "#ffbe9d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M186.4,198.03a.507.507,0,0,1-.1.262.81.81,0,0,1-.688.306c-.7,0-1.376-.808-1.616-1.748a2.839,2.839,0,0,1,0-1.387,1.2,1.2,0,0,1,.655-.939.6.6,0,0,1,.459,0,.559.559,0,0,1,.251.251.308.308,0,0,1,0,.295.319.319,0,0,0-.109-.218.394.394,0,0,0-.513-.109.93.93,0,0,0-.448.775,2.8,2.8,0,0,0,0,1.234c.218.852.808,1.54,1.332,1.606a.754.754,0,0,0,.579-.164C186.335,198.106,186.378,198.019,186.4,198.03Z",
    transform: "translate(-116.795 -172.794)",
    fill: "#eb996e"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M199.492,180.834c-.841-2.862-3.888-4.281-6.662-5.068-4.227-1.2-8.792-1.726-12.921-.208s-9.087,4.183-9.087,8.738c-2.436-.2-3.834,1.933-4.795,4.576a17.122,17.122,0,0,0-1.092,5.024h0c-.306,5.963-1.977,14.2-5.843,18.567-2.184,2.436-5.21,4.118-6.455,7.154-1.092,2.632-.524,5.756-1.54,8.421-.907,2.348-2.905,4.019-4.369,6.062a16.253,16.253,0,0,0-1.038,15.717,19.9,19.9,0,0,0,11.894,10.267,27.816,27.816,0,0,0,15.673.153,26.21,26.21,0,0,0,10.507-5.21,17.54,17.54,0,0,0,6.094-10.092c.775-4.456-.47-8.989-1.4-13.423-2.905-14.013-2.075-14.745,1.595-27.753.087-.229.131-.47.2-.7s.1-.339.142-.513h0a8.249,8.249,0,0,0,.164-1.562,3,3,0,0,1-3.156-.677,3.277,3.277,0,0,1-.743-3.277,4.761,4.761,0,0,1,2.818-2.654c1.212-.5,2.512-.765,3.7-1.322,2.523-1.2,4.27-3.692,5.461-6.3A8.649,8.649,0,0,0,199.492,180.834Z",
    transform: "translate(-120.461 -174.625)",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M186.747,198a5.349,5.349,0,0,1,.568,1.092c.328.688.765,1.66,1.245,2.785l.087.208h-.229l-1.092.1c-.754,0-1.387.142-2.13.131a.4.4,0,0,1-.284-.251.488.488,0,0,1,0-.306,4.273,4.273,0,0,1,.1-.437l.2-.775a7.345,7.345,0,0,1,.459-1.507,7.4,7.4,0,0,1-.229,1.562l-.153.775c-.055.262-.153.666,0,.633.546,0,1.322-.12,2.042-.164l1.092-.1-.142.24c-.47-1.092-.863-2.119-1.092-2.829A4.266,4.266,0,0,1,186.747,198Z",
    transform: "translate(-116.705 -172.47)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M152.547,282.294l48.439-1.474,21.079,82.286-3.877,94.387H192.576l3.135-92.378L176.98,307.83l2.883,153.322-25.885.382-2.72-144.115c-.12-4.008-1.431-13.041-.939-17.016Z",
    transform: "translate(-119.902 -164.834)",
    fill: "#009f3b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M181.953,306.891a9.683,9.683,0,0,1-2.37-.142c-1.464-.175-3.462-.481-5.658-.917s-4.161-.939-5.581-1.343a9.038,9.038,0,0,1-2.184-.786c0-.164,3.561.688,7.929,1.573S181.975,306.727,181.953,306.891Z",
    transform: "translate(-118.431 -162.727)",
    fill: "#455a64"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M214.4,437.864c0,.153-5.8.284-12.953.284s-12.964-.131-12.964-.284,5.8-.284,12.964-.284S214.4,437.7,214.4,437.864Z",
    transform: "translate(-116.373 -150.382)",
    fill: "#455a64"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M179.273,442.3c0,.164-5.636.284-12.582.284s-12.571-.12-12.571-.284,5.636-.284,12.571-.284S179.273,442.151,179.273,442.3Z",
    transform: "translate(-119.541 -149.973)",
    fill: "#455a64"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M174.3,454.552c-.153,0-.83-33.5-1.518-74.815s-1.092-74.837-.95-74.837.841,33.487,1.518,74.826S174.465,454.552,174.3,454.552Z",
    transform: "translate(-117.911 -162.614)",
    fill: "#455a64"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M210.534,452.192a2.784,2.784,0,0,1,0-.448v-1.311c0-1.18.087-2.872.153-5.024.153-4.369.371-10.714.644-18.491.59-15.64,1.42-37.2,2.326-61v-.568c-5.734-22.936-10.922-43.753-14.69-58.815L194.6,288.723c-.5-2.086-.885-3.713-1.158-4.849-.131-.535-.218-.95-.295-1.267a1.907,1.907,0,0,1-.076-.437,2.432,2.432,0,0,1,.131.426c.087.306.2.721.349,1.245.295,1.092.721,2.752,1.267,4.827,1.092,4.216,2.632,10.288,4.554,17.77,3.8,15.05,9.043,35.813,14.854,58.782v.721c-.972,23.8-1.857,45.348-2.5,60.988-.339,7.787-.623,14.089-.819,18.48-.109,2.184-.2,3.845-.251,5.024,0,.557-.066.994-.076,1.311A2.127,2.127,0,0,1,210.534,452.192Z",
    transform: "translate(-115.95 -164.71)",
    fill: "#455a64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M202.392,356.5a29.252,29.252,0,0,1-5.658,1.256c-2.359.4-4.369.688-5.275.732v-.218c.295.087.448.142.448.186s-.186,0-.491,0h-.655l.655-.2c.852-.251,2.862-.666,5.221-1.092A29.49,29.49,0,0,1,202.392,356.5Z",
    transform: "translate(-116.163 -157.857)",
    fill: "#455a64"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M201.859,359.445a28.242,28.242,0,0,1-5.1-.229,28.858,28.858,0,0,1-5.079-.557A32.339,32.339,0,0,1,201.859,359.445Z",
    transform: "translate(-116.078 -157.668)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M152.16,284.031a6.642,6.642,0,0,0,4.784,2.545,21.528,21.528,0,0,0,5.865-.109c12.506-1.387,25.754-2.665,38-5.647-15.848.885-32.591.59-48.439,1.474l-.164,1.354",
    transform: "translate(-119.722 -164.834)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(48.766 141.532)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M167.11,304.21l8.934,34.666-.623-33.2Z",
    transform: "translate(-167.11 -304.21)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvgPj);
export default __webpack_public_path__ + "static/media/loginSvgPJ.2743eb03d8e4112a08dcde369d2d359b.svg";
export { ForwardRef as ReactComponent };